import { gql } from "@apollo/client";

export const MARK_AS_SOLD = gql`
  mutation MarkAsSold(
    $logitixAmount: Float!
    $soldAmount: Float!
    $ticketPlacementId: String!
    $marketplaceName: String!
  ) {
    markAsSold(
      ticketPlacementId: $ticketPlacementId
      soldAmount: $soldAmount
      logitixAmount: $logitixAmount
      marketplaceName: $marketplaceName
    ) {
      message
    }
  }
`;
